import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "modal-header mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "mt-0.5 text-xs text-slate-500"
}
const _hoisted_3 = { class: "action-dialog-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiModal = _resolveComponent("UiModal")!

  return (_ctx.visibleActions.length === 1)
    ? (_openBlock(), _createBlock(_component_UiButton, {
        key: 0,
        variant: _ctx.visibleActions[0].variant || 'secondary',
        size: "sm",
        icon: _ctx.visibleActions[0].icon || 'edit',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.invoke(_ctx.visibleActions[0])))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.visibleActions[0].label), 1)
        ]),
        _: 1
      }, 8, ["variant", "icon"]))
    : (_ctx.visibleActions.length > 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_UiButton, {
            variant: "ghost",
            size: "sm",
            icon: "menu",
            class: "more-actions-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = true))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Thao tác ", -1)
            ]))]),
            _: 1
          }),
          (_ctx.open)
            ? (_openBlock(), _createBlock(_component_UiModal, {
                key: 0,
                size: "sm",
                onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.open = false))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-lg font-bold text-ink" }, "Thao tác", -1)),
                      (_ctx.title)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.title), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_UiButton, {
                      variant: "ghost",
                      size: "sm",
                      icon: "close",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.open = false))
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("Đóng", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleActions, (action) => {
                      return (_openBlock(), _createBlock(_component_UiButton, {
                        key: action.key || action.label,
                        variant: "ghost",
                        icon: action.icon || 'edit',
                        class: _normalizeClass(['action-dialog__button', { 'action-dialog__button--danger': action.variant === 'danger' }]),
                        onClick: ($event: any) => (_ctx.invoke(action))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(action.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["icon", "class", "onClick"]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
}